import { ValidUtils } from "./valid/index.js";
const isDefined = ValidUtils.isDefined;
export {
  isDefined
};
//# sourceMappingURL=types.js.map
